import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalConnectContext: ExperimentalQueries['experimentalConnectContext'] = (
	_,
	{ addonKey, moduleKey, spaceId, spaceKey, contentId, contentType, contentVersion, contentPlugin },
	{ network },
) => {
	const params = new URLSearchParams();
	params.append('classifier', 'json');
	if (spaceId) {
		params.append('space.id', spaceId);
	}
	if (spaceKey) {
		params.append('space.key', spaceKey);
	}
	if (contentId) {
		params.append('content.id', contentId);
	}
	if (contentType) {
		params.append('content.type', contentType);
	}
	if (contentPlugin) {
		params.append('content.plugin', contentPlugin);
	}
	if (contentVersion) {
		params.append('content.version', String(contentVersion));
	}

	// Adding all ac.* query params to request
	const activeSearchParams = new URLSearchParams(window.location.search);
	activeSearchParams.forEach((value, key) => {
		if (key.startsWith('ac.')) {
			params.append(key, value);
		}
	});

	const url = `/wiki/plugins/servlet/ac/${addonKey}/${moduleKey}?${params}`;

	return fetchJSON(network, url, {
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then(
		(data) => ({
			hasResponse: true,
			connectDescriptor: data,
		}),
		() => ({
			hasResponse: false,
			connectDescriptor: null,
		}),
	);
};
